import React from 'react'
import { Form, Input, Label, Header, Segment } from 'semantic-ui-react'
import Timer from './Timer'

export default class FormAnswer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            answer: '',
            starting_time: null
        }
        this.textInput = null;

        this.setTextInputRef = element => {
          this.textInput = element;
        };
    
        this.focusTextInput = () => {
          // Focus the text input using the raw DOM API
          if (this.textInput) this.textInput.focus();
          if (this.textInput) this.textInput.select();
        };
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
        this.focusTextInput();
    }

    onAnswerChange = (e) => this.setState({ answer: e.target.value })

    onSubmit = (e) => {
        e.preventDefault()
        this.answer()
        return false
    }

    onTimerFinished = () => {
        this.answer()
    }

    answer = () => {
        const { answer, starting_time } = this.state
        const answerMs = Date.now() - starting_time
        this.props.onAnswer(answer, answerMs)
    }


    render() {
        const { question, msToAnswer } = this.props
        const { text, specs, topic } = question
        const specLines = (specs || '').split('\n')
            .map(l => (<span style={{display: 'block'}}>{l}</span>))

        return (
            <Form onSubmit={this.onSubmit} style={{ textAlign: 'left' }}>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{topic}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>{text}</Header>
                        {specs ? <p>{specLines}</p> : null}
                        <Form.Field>
                            <label>Rispondi</label>
                            <Input onChange={this.onAnswerChange}>
                                <input ref={this.setTextInputRef} value={this.state.answer} style={{ textAlign: 'center' }} />
                            </Input>
                        </Form.Field>
                        <Form.Button primary type="submit">Rispondi</Form.Button>
                        <Timer ms={msToAnswer} />
                    </div>
                    <Timer ms={msToAnswer} isProgress={true} onFinish={this.onTimerFinished} />
                </Segment>
            </Form>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/FormAnswer.js